export var group_list = `
{{#groups}}
  {{> groups/_group_row current_tenant = ../current_tenant display_group_tags = ../display_group_tags}}
{{~/groups}}
`